import React, { useMemo } from 'react';
import format from 'date-fns/format';
import { toast } from 'components/Shared/Toast'
import { useTranslation } from 'react-i18next';

import { parseDate } from 'utils';
import { PropertyItem } from './Participant';

export function Questions({ userForm }) {

    const { t } = useTranslation();

    return (
        <div className="p-3 overflow-y-auto">
            <h4>{t('Preguntas')}</h4>
            {
                userForm.template?.questions?.map(question => {
                    const answerId = userForm.questions?.[question._id];
                    return (
                        <PropertyItem label={question.content} value={question?.answers?.find(a => a?._id === answerId)?.content || 'No se ha seleccionado una respuesta'} />
                    )
                })
            }
        </div>
    )
};

